import React from 'react';
import cl from './Policy.module.css';

const Policy = (props) => {
  return (
    <section className={cl.app_policy}>
      <h1>Informativa sulla privacy</h1>
       <h2>INFORMATIVA SULLA PRIVACY</h2>
       <p>
         Prendiamo sul serio la tua privacy e questa informativa sulla privacy spiega come{' '}
         {props.domain}(collettivamente, "noi", "ci" o "nostro") raccoglie, utilizza, condivide
         ed elaborare le tue informazioni.
       </p>

       <h2>Raccolta e utilizzo dei dati personali</h2>
       <p>
         I dati personali sono informazioni che possono essere utilizzate direttamente o indirettamente
         identificarti. I dati personali includono anche dati anonimi collegati
         a informazioni che possono essere utilizzate per identificarti direttamente o indirettamente.
         I dati personali non includono dati che sono stati irreversibili
         anonimizzato o aggregato in modo che non possa più consentirci, sia in
         combinazione con altre informazioni o altro, per identificarti.
       </p>
       <h2>Promuovere la sicurezza e la protezione</h2>
       <p>
         Ci atteniamo ai principi di legalità, legittimità e trasparenza,
         utilizzare ed elaborare il minor numero di dati entro uno scopo limitato e
         adottare misure tecniche e amministrative per proteggere la sicurezza di
         i dati. Utilizziamo i dati personali per facilitare la verifica degli account e dell'utente
         attività, nonché per promuovere la sicurezza e la protezione, come ad esempio da
         monitorare le frodi e indagare su casi sospetti o potenzialmente illegali
         attività o violazioni dei nostri termini o politiche. Tale elaborazione è
         in base al nostro legittimo interesse a contribuire a garantire la sicurezza dei nostri
         prodotti e servizi.
       </p>
       <h2>
         Ecco una descrizione dei tipi di dati personali che possiamo raccogliere e
         come possiamo usarlo:
       </h2>
       <h2>Quali dati personali raccogliamo</h2>
       <h2>ⅰ. Dati forniti:</h2>
       <p>
         Raccogliamo i dati personali che fornisci quando utilizzi i nostri prodotti e
         servizi o interagire in altro modo con noi, ad esempio quando crei un
         account, contattaci, partecipa a un sondaggio online, utilizza il nostro account online
         aiuto o strumento di chat online. Se effettui un acquisto, raccogliamo dati personali
         dati relativi all'acquisto. Questi dati includono il tuo pagamento
         dati, come il numero della tua carta di credito o debito e altra carta
         informazioni e anche altre informazioni sull'account e sull'autenticazione
         come fatturazione, spedizione e dettagli di contatto.
       </p>
       <h2>ⅱ. Dati sull'utilizzo dei nostri servizi e prodotti:</h2>
       <p>
         Quando visiti i nostri siti Web, potremmo raccogliere dati sul tipo di
         dispositivo che utilizzi, l'identificatore univoco del tuo dispositivo, l'indirizzo IP del tuo
         dispositivo, il tuo sistema operativo, il tipo di browser Internet che utilizzi
         utilizzo, informazioni sull'utilizzo, informazioni diagnostiche e informazioni sulla posizione
         da o sui computer, telefoni o altri dispositivi su cui utilizzi
         installare o accedere ai nostri prodotti o servizi. Ove disponibile, il ns
         i servizi possono utilizzare il GPS, il tuo indirizzo IP e altre tecnologie per
         determinare la posizione approssimativa di un dispositivo per consentirci di migliorare la nostra
         prodotti e servizi.
       </p>
       <h2>Come utilizziamo i tuoi dati personali</h2>
       <p>
         In generale, utilizziamo i dati personali per fornire, migliorare e
         sviluppare i nostri prodotti e servizi, per comunicare con voi, per offrirvi
         pubblicità e servizi mirati e per proteggere noi e i nostri
         clienti.
       </p>
       <h2>
         ⅰ. Fornire, migliorare e sviluppare i nostri prodotti e servizi:
       </h2>
       <p>
         Utilizziamo i dati personali per aiutarci a fornire, migliorare e sviluppare i nostri
         prodotti, servizi e pubblicità. Ciò include l'utilizzo dei dati personali
         per scopi quali analisi dei dati, ricerca e audit. Come
         il trattamento si basa sul nostro legittimo interesse a offrirti prodotti
         e servizi e per la continuità aziendale. Se partecipi a un concorso, o
         altra promozione, potremmo utilizzare i dati personali forniti per amministrare
         quei programmi. Alcune di queste attività hanno regole aggiuntive, che
         potrebbe contenere ulteriori dati su come utilizziamo i dati personali, quindi incoraggiamo
         ti invitiamo a leggere attentamente tali regole prima di partecipare.
       </p>
       <h2>ⅱ. Comunicare con te:</h2>
       <p>
         Previo tuo consenso espresso, potremmo utilizzare i dati personali per l'invio
         le tue comunicazioni di marketing in relazione ai nostri prodotti e
         servizi, comunicare con te in merito al tuo account o alle tue transazioni e
         informarti sulle nostre politiche e termini. Se non lo desideri più
         ricevere comunicazioni via email per finalità di marketing, vi preghiamo di contattarci
         abbandonare per rinuncia. Potremmo anche utilizzare i tuoi dati per elaborare e rispondere alle tue
         richieste quando ci contatti. Previo tuo previo consenso espresso, noi
         potrebbe condividere i tuoi dati personali con partner terzi che potrebbero inviarti
         comunicazioni di marketing in relazione ai propri prodotti e servizi.
         Previo tuo consenso esplicito, potremmo utilizzare i dati personali per
         personalizzare la tua esperienza con i nostri prodotti e servizi e così via
         siti Web e applicazioni di terze parti e per determinarne l'efficacia
         delle nostre campagne promozionali.
       </p>
       <p>
         NOTA: per qualsiasi utilizzo dei tuoi dati sopra descritto che richiede il tuo
         previo consenso espresso, tieni presente che potrai revocare il tuo consenso tramite
         contattandoci.
       </p>
       <h2>Definizione di "Cookie"</h2>
       <p>
         I cookie sono piccole porzioni di testo utilizzate per memorizzare informazioni sul web
         browser. I cookie sono ampiamente utilizzati per archiviare e ricevere identificatori e
         altre informazioni su computer, telefoni e altri dispositivi. Usiamo anche
         altre tecnologie, inclusi i dati che memorizziamo sul tuo browser web o
         dispositivo, identificatori associati al tuo dispositivo e altro software, per
         scopi simili. Nella presente Informativa sui cookie facciamo riferimento a tutti questi
         tecnologie come "cookie".
       </p>
       <h2>Utilizzo dei cookie</h2>
       <p>
         Utilizziamo i cookie per fornire, proteggere e migliorare i nostri prodotti e
         servizi, ad esempio personalizzando contenuti, offerte e misurazioni
         pubblicità, comprendere il comportamento degli utenti e fornire un servizio più sicuro
         esperienza. Tieni presente che i cookie specifici che potremmo utilizzare variano
         a seconda dei siti Web e dei servizi specifici utilizzati.
       </p>
       <h2>Divulgazione di dati personali</h2>
       <p>
         Mettiamo alcuni dati personali a disposizione dei partner strategici che lavorano
         con noi per fornire i nostri prodotti e servizi o aiutarci a commercializzarli
         clienti. I dati personali saranno condivisi da noi solo con queste società
         al fine di fornire o migliorare i nostri prodotti, servizi e pubblicità;
         non saranno condivisi con terzi per il loro stesso marketing
         finalità senza il tuo preventivo consenso espresso.
       </p>
       <h2>Divulgazione o archiviazione, trasferimento ed elaborazione dei dati</h2>
       <h2>ⅰ. Adempimento degli obblighi di legge:</h2>
       <p>
         A causa delle leggi obbligatorie dello Spazio economico europeo o del paese
         in cui vive l'utente, esistono o si sono verificati determinati atti giuridici e
         è necessario adempiere ad alcuni obblighi legali. Trattamento del personale
         dati dei residenti nel SEE --- Come descritto di seguito, se risiedi all'interno del
         Spazio Economico Europeo (SEE), il nostro trattamento dei tuoi dati personali sarà
         essere legittimato: Ogniqualvolta richiediamo il tuo consenso per il trattamento dei
         dei Suoi dati personali tale trattamento sarà giustificato ai sensi dell'art
         6(1) del Regolamento generale sulla protezione dei dati (UE) ("GDPR").
       </p>
       <h2>
         ⅱ. Ai fini di una ragionevole attuazione o applicazione di questo
         articolo:
       </h2>
       <p>
         Potremmo condividere i dati personali con tutte le società nostre affiliate. Nel
         caso di fusione, riorganizzazione, acquisizione, joint venture,
         cessione, scissione, trasferimento, vendita o disposizione di tutto o parte
         parte della nostra attività, anche in relazione a qualsiasi fallimento o
         procedimenti simili, potremmo trasferire tutti i dati personali a
         terza parte interessata. Potremmo anche divulgare dati personali se lo determiniamo
         in buona fede che la divulgazione è ragionevolmente necessaria per proteggere i nostri
         diritti e perseguire i rimedi disponibili, far rispettare i nostri termini e condizioni,
         indagare su frodi o proteggere le nostre operazioni o i nostri utenti.
       </p>
       <h2>ⅲ. Conformità legale e sicurezza o protezione di altri diritti</h2>
       <p>
         Potrebbe essere necessario per legge, procedimento legale, contenzioso e/o richiesta
         da autorità pubbliche e governative all'interno o all'esterno del tuo Paese
         di residenza: consentirci di divulgare i dati personali. Potremmo anche divulgare
         dati personali se stabiliamo che, per scopi di sicurezza nazionale,
         applicazione della legge o altre questioni di importanza pubblica, la divulgazione è
         necessario o opportuno.
       </p>
       <h2>Bambini</h2>
       <p>
         I nostri prodotti e servizi sono destinati agli adulti. Di conseguenza, lo facciamo
         non raccogliere, utilizzare o divulgare consapevolmente dati di bambini di età inferiore a 16 anni. Se
         apprendiamo di aver raccolto i dati personali di un minore di 16 anni,
         o l'età minima equivalente a seconda della giurisdizione, lo faremo
         adottare misure per eliminare i dati il prima possibile. Per favore, immediatamente
         contattaci se vieni a conoscenza che un minore di 16 anni ci ha fornito
         con dati personali.
       </p>
       <h2>I tuoi diritti</h2>
       <p>
         Adottiamo misure ragionevoli per garantire che i tuoi dati personali siano accurati,
         completo e aggiornato. Hai il diritto di accesso, correzione o
         eliminare i dati personali che raccogliamo. Hai anche diritto a
         limitare o opporsi, in qualsiasi momento, all'ulteriore trattamento dei Suoi
         dati personali. Hai il diritto di ricevere i tuoi dati personali in a
         formato strutturato e standard. Puoi presentare un reclamo all'
         autorità competente per la protezione dei dati in merito al trattamento dei tuoi dati
         dati personali. Per proteggere la privacy e la sicurezza dei tuoi dati personali
         dati, potremmo richiederti dati per consentirci di confermare la tua identità
         e diritto di accesso a tali dati, nonché di ricerca e fornitura
         con i dati personali che conserviamo. Ci sono casi in cui applicabile
         leggi o requisiti normativi ci consentono o ci impongono di rifiutarci di fornire
         o eliminare alcuni o tutti i dati personali che conserviamo. Potresti
         contattaci per esercitare i tuoi diritti. Risponderemo alla tua richiesta in a
         termine ragionevole e comunque inferiore a 30 giorni.
       </p>
       <h2>Siti Web e servizi di terze parti</h2>
       <p>
         Quando un cliente gestisce un collegamento a un sito Web di terzi che ha un file
         rapporto con noi, non ci assumiamo alcun obbligo o responsabilità
         per tale politica a causa della politica sulla privacy di terze parti. Nostro
         siti Web, prodotti e servizi possono contenere collegamenti o funzionalità per
         di accedere a siti Web, prodotti e servizi di terze parti. Non siamo
         responsabile delle pratiche sulla privacy impiegate da tali terze parti,
         né siamo responsabili per le informazioni o il contenuto dei loro prodotti e
         i servizi contengono. La presente Informativa sulla privacy si applica esclusivamente ai dati
         raccolti da noi attraverso i nostri prodotti e servizi. Ti invitiamo a farlo
         leggere le informative sulla privacy di eventuali terze parti prima di procedere all'utilizzo
         i loro siti Web, prodotti o servizi.
       </p>
       <h2>Sicurezza, integrità e conservazione dei dati</h2>
       <p>
         Usiamo una ragionevole sicurezza tecnica, amministrativa e fisica
         misure progettate per salvaguardare e aiutare a prevenire l’accesso non autorizzato
         i tuoi dati e di utilizzare correttamente i dati che raccogliamo. Tratterremo il tuo
         dati personali per il tempo necessario al conseguimento delle finalità
         delineato nella presente Informativa sulla privacy, a meno che non sia previsto un periodo di conservazione più lungo
         richiesto o consentito dalla legge.
       </p>
       <h2>Modifiche alla presente Informativa sulla privacy</h2>
       <p>
         Potremmo modificare periodicamente la presente Informativa sulla privacy per stare al passo con le novità
         tecnologie, pratiche di settore e requisiti normativi, tra
         altri motivi. L'uso continuato dei nostri prodotti e servizi dopo il
         data di entrata in vigore dell'Informativa sulla privacy significa che accetti la
         Informativa sulla privacy rivista. Se non sei d'accordo con la revisione contattaci
         Informativa sulla privacy, ti preghiamo di astenerti dall'utilizzare i nostri prodotti o servizi
         e contattaci per chiudere qualsiasi account che potresti aver creato.
       </p>
       <h2>Contattaci</h2>
       <p>
         In caso di domande relative alla presente Informativa sulla privacy o alla sua
         implementazione, ecco come puoi contattarci: support@{props.domain}
       </p>
    </section>
  );
};

export default Policy;
